import Header from './components/Header';
import HeroSection from './components/HeroSection';
import IndexSection from './components/IndexSection';
import FeaturesSection from './components/FeaturesSection';
import TopicsSection from './components/TopicsSection';
import CommentsSection from './components/CommentsSection';
import AboutSection from './components/AboutSection';
import RankingSection from './components/RankingSection';
import AppSection from './components/AppSection';
import ContactSection from './components/ContactSection';
import UpdatesSection from './components/UpdatesSection';
import CarouselSection from './components/CarouselSection';
import FaqSection from './components/FaqSection';
import MediaSection from './components/MediaSection';
import CardsSection from './components/CardsSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <Header />
      <main>
        <HeroSection />
        <IndexSection />
        <FeaturesSection />
        <TopicsSection />
        <CommentsSection />
        <AboutSection />
        <RankingSection />
        <AppSection />
        <ContactSection />
        <UpdatesSection />
        <CarouselSection />
        <FaqSection />
        <MediaSection />
        <CardsSection />
      </main>
      <Footer />
    </div>
  );
}